import React from "react";

import Image from "next/image";
import { Typography, Card, CardBody } from "@material-tailwind/react";

interface InfoCardProps {
  title: string;
  children: React.ReactNode;
  img: string;   
  titleClassName?: string;  
}

export function InfoCard({
  title,
  children,
  img,
  titleClassName = "",
}: InfoCardProps) {
  return (
    <Card
      {...({} as any)}
      color="transparent"
      shadow={false}
      className="border border-gray-300 rounded-xl"
    >
      <CardBody
        {...({} as any)}
        className="grid px-2 py-2 gap-4 bg-white rounded-[20px]"
      >
        <div className="w-16 h-16 mx-auto">
          <Image
            src={img}
            alt={title}
            width={64}
            height={64}
            className="object-contain"
          />
        </div>

        <Typography 
          {...({} as any)}
          variant="h2"
          color="blue-gray"
          className={`font-semibold mb-2 text-center ${titleClassName}`}
        >
         
          {title}
        </Typography>

        <Typography {...({} as any)} variant="h5" className="text-[#2998E2] font-normal text-center">
          {children}
        </Typography>
      </CardBody>
    </Card>
  );
}

export default InfoCard;
